var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8327 8.16211V18.4159C23.8327 19.2448 23.516 20.0425 22.9473 20.6456C22.3786 21.2488 21.6009 21.6118 20.7733 21.6604L20.5827 21.6659H5.41602C4.58704 21.6659 3.78937 21.3492 3.18623 20.7805C2.58309 20.2118 2.22007 19.4341 2.17143 18.6065L2.16602 18.4159V8.16211L12.3981 14.9839L12.5238 15.0554C12.6719 15.1277 12.8345 15.1653 12.9993 15.1653C13.1642 15.1653 13.3268 15.1277 13.4749 15.0554L13.6006 14.9839L23.8327 8.16211Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.583 4.33301C21.753 4.33301 22.7789 4.95051 23.3509 5.87892L12.9997 12.7798L2.64844 5.87892C2.92013 5.43782 3.29334 5.06805 3.73694 4.80045C4.18055 4.53286 4.68169 4.37519 5.1986 4.34059L5.41635 4.33301H20.583Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.16bc12509c71be127f67e30f73d25c36.svg";
export { ForwardRef as ReactComponent };